#@export CountdownTimer.Helpers

timeRemaining = (timeRemainingMilliseconds) ->
  return {days:0, hours:0, minutes:0, seconds:0} unless timeRemainingMilliseconds?
  days = Math.floor(timeRemainingMilliseconds / (1000 * 3600 * 24))
  millisecondsLeft = Math.floor(timeRemainingMilliseconds - days * (1000 * 3600 * 24))
  hours = Math.floor(millisecondsLeft / (1000 * 3600))
  millisecondsLeft = Math.floor(millisecondsLeft - hours * (1000 * 3600))
  minutes = Math.floor(millisecondsLeft / (1000 * 60))
  millisecondsLeft = Math.floor(millisecondsLeft - minutes * 1000 * 60)
  seconds = Math.floor(millisecondsLeft / 1000)
  {days, hours, minutes, seconds}

millisRemaining = (endTime) ->
  return 0 unless endTime?
  rightNow = new Date().getTime()
  millsRemaining = endTime - rightNow
  if millsRemaining < 0 then 0 else millsRemaining

addLeadingZero = (number) ->
  return if number < 0
  if number < 10 then "0#{number}" else "#{number}"

countdownTimeKey = (timeLeft, ignoreCap = false) ->
  switch
    when timeLeft.days >= 15 and not ignoreCap then ""
    when timeLeft.days > 1 then ".countdown_time_many_days"
    when timeLeft.days is 1 then ".countdown_time_1_day"
    else ".countdown_time_today"

countdownTimestamp = (timeLeft) ->
  hh = addLeadingZero timeLeft.hours
  mm = addLeadingZero timeLeft.minutes
  ss = addLeadingZero timeLeft.seconds
  "#{hh}:#{mm}:#{ss}"

shouldShowTimerForGoods = (dealTimer, timeLeft) ->
  switch dealTimer
    when 'lessThanEqualTo7Days'
      timeLeft.days < 7 or (timeLeft.days is 7 and
      timeLeft.hours is 0 and timeLeft.minutes is 0 and timeLeft.seconds is 0)
    when 'lessThanEqualTo3Days'
      timeLeft.days < 3 or (timeLeft.days is 3 and
      timeLeft.hours is 0 and timeLeft.minutes is 0 and timeLeft.seconds is 0)
    when 'lessThanEqualTo1Day'
      timeLeft.days < 1 or (timeLeft.days is 1 and
      timeLeft.hours is 0 and timeLeft.minutes is 0 and timeLeft.seconds is 0)
    when 'lessThanEqualTo12Hrs'
      (timeLeft.days is 0 and timeLeft.hours < 12) or
      (timeLeft.days is 0 and timeLeft.hours is 12 and timeLeft.minutes is 0 and timeLeft.seconds is 0)
    else
      return true

if window?
  window.CountdownTimer ?= {}
  CountdownTimer.Helpers?= {}
  CountdownTimer.Helpers.timeRemaining= timeRemaining
  CountdownTimer.Helpers.millisRemaining = millisRemaining
  CountdownTimer.Helpers.countdownTimeKey = countdownTimeKey
  CountdownTimer.Helpers.countdownTimestamp = countdownTimestamp
  CountdownTimer.Helpers.shouldShowTimerForGoods = shouldShowTimerForGoods

if module?
  module.exports = {timeRemaining, millisRemaining, countdownTimeKey, countdownTimestamp, shouldShowTimerForGoods}

